import { IEditModifierRestaurantPropertiesState } from './editModifierRestaurantPropertiesContext';
import {
	TEditModifierRestaurantPropertiesAction,
	EditModifierRestaurantPropertiesActionTypes,
} from './editModifierRestaurantPropertiesActions';

export const editModifierRestaurantPropertiesReducer = (
	state: IEditModifierRestaurantPropertiesState,
	action: TEditModifierRestaurantPropertiesAction,
): IEditModifierRestaurantPropertiesState => {
	switch (action.type) {
		case EditModifierRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_ALL_DATA:
			return {
				...state,
				modifierId: action.payload.modifierId,
				modifierName: action.payload.modifierName,
				customerName: action.payload.customerName,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				price: action.payload.price,
				supplementPrice: action.payload.supplementPrice,
				isCreatedFromPos: action.payload.isCreatedFromPos,
				quantityMaxLimit: action.payload.quantityMaxLimit,
				inStop: action.payload.inStop,
				isRestricted: action.payload.isRestricted,
				isPreselected: action.payload.isPreselected,
				forceDisable: action.payload.forceDisable,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				parentModifierGroups: action.payload.parentModifierGroups,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				hasPortions: action.payload.hasPortions,
				portionSelectionMode: action.payload.portionSelectionMode,
				hasPortionBasedNestedModGroups: action.payload.hasPortionBasedNestedModGroups,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT:
			return {
				...state,
				price: action.payload.price,
				supplementPrice: action.payload.supplementPrice,
				isCreatedFromPos: action.payload.isCreatedFromPos,
				quantityMaxLimit: action.payload.quantityMaxLimit,
				inStop: action.payload.inStop,
				isRestricted: action.payload.isRestricted,
				isPreselected: action.payload.isPreselected,
				forceDisable: action.payload.forceDisable,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				parentModifierGroups: action.payload.parentModifierGroups,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				hasPortions: action.payload.hasPortions,
				portionSelectionMode: action.payload.portionSelectionMode,
				hasPortionBasedNestedModGroups: action.payload.hasPortionBasedNestedModGroups,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_SUPPLEMENT_PRICE:
			return {
				...state,
				supplementPrice: action.payload.supplementPrice,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_QUANTITY_MAX_LIMIT:
			return {
				...state,
				quantityMaxLimit: action.payload.quantityMaxLimit,
			};
		case EditModifierRestaurantPropertiesActionTypes.TOGGLE_IN_STOP:
			return {
				...state,
				inStop: !state.inStop,
			};
		case EditModifierRestaurantPropertiesActionTypes.TOGGLE_IS_RESTRICTED:
			return {
				...state,
				isRestricted: !state.isRestricted,
			};
		case EditModifierRestaurantPropertiesActionTypes.TOGGLE_IS_PRESELECTED:
			return {
				...state,
				isPreselected: !state.isPreselected,
			};
		case EditModifierRestaurantPropertiesActionTypes.TOGGLE_FORCE_DISABLE:
			return {
				...state,
				forceDisable: !state.forceDisable,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_PORTION_SELECTION_MODE:
			return {
				...state,
				portionSelectionMode: action.payload.portionSelectionMode,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP:
			return {
				...state,
				IDsSelectedModifierGroups: action.payload.IDsSelectedModifierGroups,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA:
			return {
				...state,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
			};
		case EditModifierRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModifierRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditModifierRestaurantPropertiesActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		default:
			return state;
	}
};
